// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/not_entitled_reason.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/not_entitled_reason.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_not_entitled_reason = /*@__PURE__*/
  fileDesc("CkFzdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvbm90X2VudGl0bGVkX3JlYXNvbi5wcm90bxInc3R1ZHlvLnRvZGF5LnN1YnNjcmlwdGlvbnMudjEucmVzb3VyY2VzKo4CChFOb3RFbnRpdGxlZFJlYXNvbhIjCh9OT1RfRU5USVRMRURfUkVBU09OX1VOU1BFQ0lGSUVEEAASJwojTk9UX0VOVElUTEVEX1JFQVNPTl9OT19TVUJTQ1JJUFRJT04QARItCilOT1RfRU5USVRMRURfUkVBU09OX0NBTkNFTEVEX1NVQlNDUklQVElPThACEiwKKE5PVF9FTlRJVExFRF9SRUFTT05fRVhQSVJFRF9TVUJTQ1JJUFRJT04QAxIlCiFOT1RfRU5USVRMRURfUkVBU09OX0VYUElSRURfVFJJQUwQBBInCiNOT1RfRU5USVRMRURfUkVBU09OX0xJTUlUU19FWENFRURFRBAFQi+qAixTdHVkeW8uVG9kYXkuU3Vic2NyaXB0aW9ucy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.subscriptions.v1.resources.NotEntitledReason.
 */
export const NotEntitledReasonSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_subscriptions_v1_resources_not_entitled_reason, 0);

/**
 * Represents why an entitlement is not met.
 *
 * @generated from enum studyo.today.subscriptions.v1.resources.NotEntitledReason
 */
export const NotEntitledReason = /*@__PURE__*/
  tsEnum(NotEntitledReasonSchema);

